import React from 'react'
import withFmsLayout from '../layout/withFmsLayout'
import { Link } from 'react-router-dom';
import { DocumentScanner, QrCode2, ScreenSearchDesktop } from '@mui/icons-material';

function FmsDashboardPage() {
  return (
          <div className='container'>
            <div className='row mt-5 text-center'>

              <div className='col-md-4 my-3'>
                  <div className='card bg-primary p-3 ' >
                    <Link to={"/fms/search"} className='btn text-white'   >
                      <h3><ScreenSearchDesktop style={{fontSize:60}} /></h3>
                      <p>Search Document</p>
                    </Link>
                  </div>
              </div>
              
              <div className='col-md-4 my-3'>
                  <div className='card bg-success p-3 ' >
                    <Link to={"/fms/document-list"} className='btn text-white'   >
                      <h3><DocumentScanner style={{fontSize:60}} /></h3>
                      <p>Manage Dcouments</p>
                    </Link>
                  </div>
              </div>
    
              <div className='col-md-4 my-3'>
                  <div className='card bg-dark p-3 ' >
                    <Link to={"/fms/barcode-list"} className='btn text-white'   >
                      <h3><QrCode2 style={{fontSize:60}} /></h3>
                      <p>ManageBarcode</p>
                    </Link>
                  </div>
              </div>
    
              
            </div>
          </div>
  )
}

export default withFmsLayout(FmsDashboardPage);